import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './SoftwareSkill.css';

const SoftwareSkill = ({ logos }) => {
  return (
    <div>
      <div className='software-skills-main-div'>
        <ul className='dev-icons'>
          {logos.map((logo) => {
            return (
              <OverlayTrigger
                key={logo.skillName}
                placement={'top'}
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    <strong>{logo.skillName}</strong>
                  </Tooltip>
                }
              >
                <li className='software-skill-inline' name={logo.skillName}>
                  <span
                    className='iconify'
                    data-icon={logo.fontAwesomeClassname}
                    style={logo.style}
                    data-inline='false'
                  ></span>
                </li>
              </OverlayTrigger>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SoftwareSkill;
